"use strict";

const GroupConfiguration = function () {
  const stringKey = "group-configuration";
  const tabHeader = "Group";

  var _onToolAccessInput = function (e, value, pathParts, formState, formKey) {
    const toolId = $(this).data("tool-id");
    const toolAccess = { ...formState.groupConfiguration?.toolAccess, [toolId]: value };
    Form.manuallySetFormDataField(formKey, ["groupConfiguration", "toolAccess"], toolAccess);
  };

  var _onPortalAccessInput = function (e, value, pathParts, formState, formKey) {
    const toolId = $(this).data("tool-id");
    const portalAccess = { ...formState.groupConfiguration?.portalAccess, [toolId]: value };
    Form.manuallySetFormDataField(formKey, ["groupConfiguration", "portalAccess"], portalAccess);
  };

  var _onExportShapefilesClick = async function () {
    const groupId = Tree.get("activeGroup", "groupId");

    try {
      await ApiCalls.exportAllShapefilesToEmail(groupId);
      MessageModal.showSimpleWarningModal(
        "Your shapefile export is being prepared and will be emailed to you when ready.",
      );
    } catch {
      MessageModal.showSimpleWarningModal("The shapefile export failed. Please try again later.");
    }
  };

  var loadListeners = function (data) {
    $("#assessment-modal").on("2N:FormInput", ".tool-access-toggle", _onToolAccessInput);
    $("#assessment-modal").on("2N:FormInput", ".portal-access-toggle", _onPortalAccessInput);
    $("#assessment-modal").on("click", ".export-shapefiles-button", _onExportShapefilesClick);
  };

  var unloadListeners = function () {
    $("#assessment-modal").off("2N:FormInput", ".tool-access-toggle", _onToolAccessInput);
    $("#assessment-modal").off("2N:FormInput", ".portal-access-toggle", _onPortalAccessInput);
    $("#assessment-modal").off("click", ".export-shapefiles-button", _onExportShapefilesClick);
  };

  var getProps = function (data) {
    const groupConfig = data.groupConfiguration || {};

    return {
      groupConfigurationProps: {
        tools: groupConfig.tools || [],
        relations: groupConfig.relations,
      },
    };
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
    _onExportShapefilesClick,
  };
};

module.exports = GroupConfiguration();

const ApiCalls = require("../../apiCalls");
const Form = require("../../general/form");
const MessageModal = require("../../modals/messageModal");
const Tree = require("../../tree");
